
export default defineNuxtRouteMiddleware(async (_to, _from) => {
  return navigateTo('/dashboard/projects')
})
